import React, { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Checkbox, Tooltip } from "@activecollab/components";
import classNames from "classnames";
import PropTypes from "prop-types";
import { useBatchEditContext } from "./context";

export const ItemGroupCheckbox = ({ id, items, className }) => {
  const { t } = useTranslation();
  const { open: batchOpen, selectedIds, setSelectedIds } = useBatchEditContext();

  const editableIds = useMemo(() => {
    return items.reduce((prev, next) => {
      prev.push(next.id);
      return prev;
    }, []);
  }, [items]);

  const checked = editableIds.every((id) => selectedIds.includes(id)) && editableIds.length > 0;

  const isEditableIdsEmpty = editableIds.length === 0;

  const isMixed = selectedIds.some((id) => editableIds.includes(id)) && checked === false;

  const handleCheck = useCallback(
    (e) => {
      if (e.target.checked) {
        setSelectedIds([...new Set([...selectedIds, ...editableIds])]);
      } else {
        const newIds = selectedIds.filter((id) => !editableIds.includes(id));
        setSelectedIds(newIds);
      }
    },
    [editableIds, selectedIds, setSelectedIds]
  );
  return batchOpen ? (
    <Tooltip
      disable={!isEditableIdsEmpty}
      title={t("Locked")}
    >
      <div className={classNames("tw-ml-1 tw-mr-3", className)}>
        <Checkbox
          id={`item-group-${id}`}
          checked={checked}
          onChange={handleCheck}
          mixed={isMixed}
          disabled={isEditableIdsEmpty}
        />
      </div>
    </Tooltip>
  ) : null;
};

ItemGroupCheckbox.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  items: PropTypes.array,
  className: PropTypes.string,
};

ItemGroupCheckbox.defaultProps = {
  items: [],
};
